import "./Home.scss"
import React from "react"
import { Button, Footer } from "../lib"
import HomeSection from "./HomeSection"
import Trend from "./Trend"
// images
import brandImg from "../assets/unstuck-group-logo-large.png"
import homeImg from "../assets/homepage-assess-info.png"
import assessImg from "../assets/homepage-assess-info-2.png"

const Home = () => {
  return (
    <div className="Home">
      <HomeSection className="Home_landing" background={homeImg}>
        <h1>
          Where Is Your Church<br />In Its Life Cycle?
        </h1>
        <p>
          Over time, most organizations start, grow, thrive, decline, and
          eventually end.<br />
          <i>But that’s not God’s plan for the Church.</i>
        </p>
        <Button styleType="primary" to="/assess">
          Assess your church
        </Button>
      </HomeSection>
      <HomeSection className="Home_world">
        <h1>Life Cycle Trends by Category</h1>
        <p>
          Regardless of uniqueness, every church has the potential<br />to go
          through a very similar life cycle.
        </p>
        <p>
          Filter our comprehensive data by category to see how things like
          church denomination, average attendance, location, and conversion and
          giving numbers correlate to the seven stages of the typical life cycle
          of a church.
        </p>
        <Trend />
      </HomeSection>
      <HomeSection className="Home_features" background={assessImg}>
        <h1>Assess your church</h1>
        <ul>
          <li>
            <h2>Assess your church as a leadership&nbsp;team</h2>
            <p>
              Invite members of your staff and/or lay leader team to take the
              survey with you, and combine the whole group’s responses into one
              comprehensive report. This version is the most accurate, as it
              also asks you to input just a few objective metrics about your
              church, in addition to your team’s opinion data.
            </p>
          </li>
          <li>
            <h2>Assess your church as an&nbsp;individual</h2>
            <p>
              Take the survey as an individual to determine where your church is
              in its life cycle. This survey’s results will be calcuated from
              the opinions you input.
            </p>
          </li>
          <li>
            <h2>Download a detailed&nbsp;report</h2>
            <p>
              View your results, along with recommended next steps based on your
              church’s life cycle stage, in a downloadable report.
            </p>
          </li>
        </ul>
        <footer>
          <Button styleType="primary" to="/assess/leader">
            Leadership Assessment
          </Button>
          <Button styleType="primary" to="/assess/member">
            Individual Assessment
          </Button>
        </footer>
      </HomeSection>
      <HomeSection className="Home_quotes">
        <ul>
          <li>
            <p>
              "This became a turning point for our Leadership Team and
              Congregation - thanks @UnstuckGroup for your resources - they have
              helped to clear a path so that we can move forward."
            </p>
            <p>
              <i>Les Burrows, Area Commander, The Salvation Army Canada</i>
            </p>
          </li>
          <li>
            <p>
              "This will give us a powerful tool for our next leadership meeting
              to help me FINALLY create some urgency and implement some new
              focus and leadership focus. This report should be a real wake up
              call at last."
            </p>
            <p>
              <i>Mike Bobula, Latrobe First Church of God</i>
            </p>
          </li>
        </ul>
      </HomeSection>
      <HomeSection className="Home_about">
        <img
          src={brandImg}
          alt="unstuck group"
          style={{ width: "100%", maxWidth: 500, marginBottom: 20 }}
        />
        <p>
          The Unstuck Group helps churches grow their impact through consulting
          and coaching experiences designed to focus vision, strategy and
          action.
        </p>
        <Button
          styleType="primary"
          target="_blank"
          href="https://theunstuckgroup.com/"
        >
          Learn How
        </Button>
      </HomeSection>
      <Footer />
    </div>
  )
}

Home.displayName = "Home"

export default Home



// WEBPACK FOOTER //
// ./src/home/Home.js